import DepartureFilter from './departure-filter.js';

/**
 * Simple Departure Filter Manager
 *
 * Initializes and manages all departure filters on the page.
 */
export default class DepartureFilterManager {
	constructor() {
		this.filters = [];
	}

	/**
	 * Initialize all filters
	 */
	init() {
		this.initTabbedFilters();
		this.initDropdownFilters();
		this.initNoFilterLayouts();
	}

	/**
	 * Initialize tabbed filters
	 */
	initTabbedFilters() {
		const containers = document.querySelectorAll(
			'.departure-filter--tabbed'
		);
		containers.forEach((container, index) => {
			try {
				const options = this.getFilterOptions(container, 'tabbed');
				const filter = new DepartureFilter(container, options);
				this.filters.push(filter);
			} catch (error) {
				// Silently handle errors
			}
		});
	}

	/**
	 * Initialize dropdown filters
	 */
	initDropdownFilters() {
		const containers = document.querySelectorAll(
			'.departure-filter--dropdown'
		);
		containers.forEach((container, index) => {
			try {
				const options = this.getFilterOptions(container, 'dropdown');
				const filter = new DepartureFilter(container, options);
				this.filters.push(filter);
			} catch (error) {
				// Silently handle errors
			}
		});
	}

	/**
	 * Initialize no filter layouts
	 */
	initNoFilterLayouts() {
		const containers = document.querySelectorAll(
			'.departure-filter--no-filter'
		);
		containers.forEach((container, index) => {
			try {
				const options = this.getFilterOptions(container, 'none');
				const filter = new DepartureFilter(container, options);
				this.filters.push(filter);
			} catch (error) {
				// Silently handle errors
			}
		});
	}

	/**
	 * Get filter options from container
	 */
	getFilterOptions(container, filterType) {
		return {
			filterType: filterType,
			isHome: container.getAttribute('data-is-home') === 'true',
			productId: parseInt(
				container.getAttribute('data-product-id') || '0',
				10
			),
			limit: parseInt(
				container.getAttribute('data-limit') || '10',
				10
			),
			loadMoreEnabled: container.getAttribute('data-load-more-enabled') === 'true',
		};
	}

	/**
	 * Destroy all filters
	 */
	destroy() {
		this.filters.forEach((filter) => {
			try {
				filter.destroy();
			} catch (error) {
				// Silently handle errors
			}
		});
		this.filters = [];
	}

	/**
	 * Get filter count
	 */
	getFilterCount() {
		return this.filters.length;
	}
}
